import type { FastifyInstance, FastifyRequest } from 'fastify'
import type { UsersController } from './users.controller'
import { authMiddleware } from '../../middleware/auth.middleware'

export async function usersRoutes(
  app: FastifyInstance,
  controller: UsersController
) {
  app.addHook('onRequest', authMiddleware)

  app.get(
    '/me/stats',
    async (request: FastifyRequest, reply) => {
      return controller.getUserStats(request, reply)
    }
  )

  app.post(
    '/me/location',
    async (request: FastifyRequest, reply) => {
      return controller.updateLocation(request, reply)
    }
  )

  app.get(
    '/me/location/summary',
    async (request: FastifyRequest, reply) => {
      return controller.getLocationSummary(request, reply)
    }
  )
}
